import { useLocation, useParams } from 'react-router-dom';
import useOrgId from './useOrgId.js';
import useOrganizations from './useOrganizations.js';
import { CLIENT_PRODUCT } from 'constants/products.js';

const useClientId = () => {
  const { pathname } = useLocation();
  const { clientId } = useParams();
  const orgId = useOrgId();
  const { data: organizations } = useOrganizations();

  if (clientId && pathname.startsWith(`/${CLIENT_PRODUCT}/`)) {
    // Get client ID directly from URL
    return clientId;
  } else if (orgId) {
    // Get client ID from current selected organization
    const organization = organizations?.find((org) => org.id === orgId);
    if (organization?.clientId) return organization.clientId;
  }

  return undefined;
};

export default useClientId;
